import React, { useState } from "react";
import { LeafGlyph } from "@/components/BotanicalBackdrop";
import BotanicalIcon from "@/components/BotanicalIcon";

// Premium image loader for product cards. If the image fails or none is provided,
// renders an elegant composed placeholder using the product's category iconography.
export const ProductImage = ({ product, className = "", imgClassName = "" }) => {
  const [failed, setFailed] = useState(false);
  const hasImage = product.heroImage && !failed;

  // Map slugs to appropriate botanical icon variants for fallback
  const iconMap = {
    "sea-buckthorn-pure-pulp": "berry",
    "man-360": "root",
    "shilajit-for-men": "mineral",
    "shilajit-for-women": "mineral",
    "sugar-free-wellness-syrup": "vine",
  };
  const accentMap = {
    "sea-buckthorn-pure-pulp": "#D97535",
    "man-360": "#8B5A2B",
    "shilajit-for-men": "#3E3629",
    "shilajit-for-women": "#7A4A5F",
    "sugar-free-wellness-syrup": "#3A6E42",
  };
  const iconVariant = iconMap[product.slug] || "root";
  const accent = accentMap[product.slug] || "#D97535";

  return (
    <div className={"relative w-full h-full overflow-hidden bg-[var(--hk-warm-ivory)] " + className}>
      {hasImage && (
        <img
          src={product.heroImage}
          alt={product.name}
          onError={() => setFailed(true)}
          className={"w-full h-full object-cover transition-transform duration-700 " + imgClassName}
          loading="lazy"
        />
      )}
      {!hasImage && (
        <div
          className="absolute inset-0"
          style={{
            background:
              `radial-gradient(circle at 30% 25%, ${accent}22, transparent 65%),` +
              `radial-gradient(circle at 70% 80%, ${accent}18, transparent 60%),` +
              `linear-gradient(160deg, #F5EFE4 0%, #EFE6D4 55%, ${accent}22 100%)`,
          }}
        >
          <div className="absolute inset-8 rounded-full border" style={{ borderColor: `${accent}22` }} />
          <div className="absolute inset-16 rounded-full border" style={{ borderColor: `${accent}18` }} />
          <div className="absolute inset-0 flex items-center justify-center p-8" style={{ color: accent }}>
            <div className="w-32 h-32 md:w-44 md:h-44">
              <BotanicalIcon variant={iconVariant} />
            </div>
          </div>
          <div className="absolute top-4 right-4 opacity-70" style={{ color: accent }}>
            <LeafGlyph className="w-5 h-5" />
          </div>
          <div className="absolute bottom-4 left-4 text-[10px] tracking-[0.28em] uppercase" style={{ color: accent }}>
            HerbKranti
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductImage;
